module.exports = __webpack_public_path__ + "img/courseImg.c4f36b1c.png";